import script from "./AudioClue.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioClue.vue?vue&type=script&setup=true&lang=js"

import "./AudioClue.vue?vue&type=style&index=0&id=abeb38c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abeb38c4"]])

export default __exports__